export const makeErrorWrapper = () => {
    return `
    margin: 0 auto;
    background-color: #ffffff;
    `;
};
export const makeErrorImage = ({ theme }) => {
    return `
    width: 100%;
    max-width: 288px;
    margin: 0 auto 40px;

    @media (min-width: ${theme.screen.mdMin}){
      max-width: 344px;
      margin: 0px auto;
    }
   
    @media (min-width: ${theme.screen.lgMin}){
      max-width: 376px;
      margin: 0px 24px 0px 0px;
    }

    @media (min-width: ${theme.screen.xlMin}){
      max-width: 556px;
    }
    `;
};
export const makeElementsContainer = ({ theme }) => {
    return `
    display: block;
    text-align:left;
    padding: 0 16px;
    margin: 64px auto 152px;  

    @media (min-width: ${theme.screen.mdMin}){
      display:flex;
      padding: 0 30px;
      align-items: top;
      margin: 88px auto 275px;
      justify-content: center;
      max-width: 1136px; 
    }

    @media (min-width: ${theme.screen.lgMin}){
      margin-bottom: 258px;
      padding: 0 16px;
    }
    `;
};
export const makePageTitle = ({ theme }) => {
    return `
    font-size: 24px;
    line-height: 32px;
    color: ${theme.colors.secondary.normal};
    font-weight: 600;

    @media (min-width: ${theme.screen.mdMin}){
      font-size: 32px;
      line-height: 40px;
    }

    @media (min-width: ${theme.screen.xlMin}){
      font-size: 52px;
      line-height: 64px;
    }
  `;
};
export const makeSubtitle = ({ theme }) => {
    return `
    font-size: 16px;
    line-height: 20px;
    color: rgba(0, 0, 24, 0.84);
    margin: 24px 0px 0px;

    @media (min-width: ${theme.screen.lgMin}){
      font-size: 24px;
      line-height: 32px;
      margin: 40px 0px 0px; 
    }
  `;
};
